import { render, staticRenderFns } from "./PrintListDocx.vue?vue&type=template&id=3452390b&"
import script from "./PrintListDocx.vue?vue&type=script&lang=ts&"
export * from "./PrintListDocx.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3452390b')) {
      api.createRecord('3452390b', component.options)
    } else {
      api.reload('3452390b', component.options)
    }
    module.hot.accept("./PrintListDocx.vue?vue&type=template&id=3452390b&", function () {
      api.rerender('3452390b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/PrintListDocx.vue"
export default component.exports